import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { useFetch, PageHeader, SectionCard, Loading } from "@/lib/ui";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PayoutReview } from "@/components/PayoutReview";

function PayoutSettings() {
  const { data, loading, refetch } = useFetch("/admin/payout-settings", []);
  const [min, setMin] = useState(""); const [time, setTime] = useState(""); const [busy, setBusy] = useState(false);
  useEffect(() => { if (data) { setMin(String(data.min_amount)); setTime(data.eligibility_time); } }, [data]);
  if (loading) return <Loading />;
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/payout-settings", { min_amount: Number(min), eligibility_time: time }); toast.success("Payout settings saved"); refetch(); }
    catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };
  return (
    <SectionCard className="p-5 mb-6" data-testid="payout-settings">
      <h3 className="font-semibold font-outfit mb-1">Payout settings</h3>
      <p className="text-xs text-muted-foreground mb-3">Orders delivered on a day become payable the next day at the eligibility time (India time). Unpaid days add up. Payouts stay manual: send money from your business bank, then record the UTR.</p>
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-xs">Minimum payout (₹)<Input type="number" min="1" value={min} onChange={(e) => setMin(e.target.value)} className="w-36" data-testid="payout-min-input" /></label>
        <label className="text-xs">Eligibility time (IST)<Input type="time" value={time} onChange={(e) => setTime(e.target.value)} className="w-36" data-testid="payout-time-input" /></label>
        <Button onClick={save} disabled={busy || !(Number(min) >= 1) || !time} data-testid="payout-settings-save">Save</Button>
      </div>
    </SectionCard>
  );
}

export default function Payouts() {
  return (
    <div>
      <PageHeader title="Shop Payouts" subtitle="Daily cumulative payouts, sent manually and recorded with the bank reference" />
      <PayoutSettings />
      <PayoutReview />
    </div>
  );
}
